import { ApolloProvider as ApolloProviderWrapper } from '@apollo/client/react';
import { FC, ReactNode, useMemo } from 'react';

import { useAuthContext } from '@services/Auth';

import { createClient } from '../../apollo';

interface ApolloProviderProps {
  children: ReactNode;
}

// Ensures Apollo client in not recreated on every route change
const ApolloProvider: FC<ApolloProviderProps> = ({ children }) => {
  const { getToken } = useAuthContext();
  const client = useMemo(() => createClient(getToken), [getToken]);

  return (
    <ApolloProviderWrapper client={client}>{children}</ApolloProviderWrapper>
  );
};

export { ApolloProvider };
